import { useApolloClient } from "@apollo/client/react/hooks"
import { useEffect } from "react"

import { Project } from "shared/types/Project"

import { cacheProjects } from "entities/projects/lib/cacheProjects"

export function useProjectsCache(projects: Project[] | null | undefined) {
  const { cache } = useApolloClient()
  useEffect(() => {
    if (projects && Array.isArray(projects)) {
      cacheProjects(cache, projects)
    }
  }, [projects])
}
